/* ============================================================
   HEMP HOUNDS — Shopify migration · SHARED JS
   Global, section-agnostic behaviours. Section-specific JS
   lives in each section's {% javascript %} block.
   Loaded once (defer) from theme.liquid.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal-on-scroll (adds .in to .hh .reveal) ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.hh .reveal:not(.in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    /* threshold 0 = reveal as soon as ANY part is on screen. A ratio threshold (was .12) can never be
       met by an element taller than ~8x the viewport (e.g. a long blog post), which stayed invisible. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- ADD TO CART (shared, AJAX → theme cart drawer, native fallback) ----------
     Reuses the theme's <cart-container> Section-Rendering logic (Req 15 — borrow the
     FUNCTION, keep our UI). Every <form class="prod-add-form"> (or [data-hh-cart-add]) is
     handled automatically via event delegation, so sections need NO add-to-cart JS of
     their own: a spinner shows on the submit button, the item is added, the theme's cart
     count + offcanvas drawer re-render, our header count syncs, and the drawer opens. On a
     network error it falls back to a native form POST so the shopper is never stuck. */
  function btnLoading(btn, on) {
    if (!btn) return;
    if (on) { btn.dataset.hhOrig = btn.innerHTML; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    else { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
  }
  function btnResult(btn, ok, label) {
    if (!btn) return;
    var orig = btn.dataset.hhOrig != null ? btn.dataset.hhOrig : btn.innerHTML;
    if (ok) {
      btn.classList.add('is-added');
      btn.innerHTML = '<svg><use href="#s-check"/></svg> ' + (label || btn.getAttribute('data-added-label') || 'added');
    } else {
      btn.classList.add('is-error');
      btn.innerHTML = orig;
    }
    setTimeout(function () { btn.classList.remove('is-added', 'is-error'); btn.innerHTML = orig; }, 1800);
  }
  function syncHeaderCount(sections) {
    var count = null;
    try {
      var html = sections && (sections['cart-count-badge'] || sections['cart-count']);
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var badge = doc.querySelector('.cart-count-badge, [data-cart-count], .cart-count');
        if (badge) { var m = (badge.textContent || '').match(/\d+/); if (m) count = m[0]; }
      }
    } catch (e) {}
    if (count == null) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-hh-cart-count]'), function (el) {
      el.textContent = count; el.classList.toggle('show', parseInt(count, 10) > 0);
    });
  }
  var cartBusy = false;
  function cartAdd(form, btn) {
    if (!form) return;
    btn = btn || form.querySelector('button[type="submit"], .prod-add, .btn');
    if (cartBusy || (btn && (btn.classList.contains('is-loading') || btn.hasAttribute('disabled')))) return;
    cartBusy = true;
    btnLoading(btn, true);

    var fd = new FormData(form);
    fd.append('sections', 'cart-count-badge,offcanvas-cart');
    fd.append('sections_url', window.location.pathname);
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url) ? window.Shopify.routes.cart_add_url : '/cart/add';

    fetch(route + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        cartBusy = false;
        btnLoading(btn, false);
        if (!res.ok) {
          btnResult(btn, false);
          if (res.data && res.data.description) console.warn('[HH cart] ' + res.data.description);
          return;
        }
        var cc = document.querySelector('cart-container');
        if (cc && typeof cc.reloadCartElements === 'function' && res.data.sections) cc.reloadCartElements(res.data.sections);
        syncHeaderCount(res.data.sections);
        var oc = document.getElementById('offcanvas-cart');
        if (oc && window.bootstrap && window.bootstrap.Offcanvas) window.bootstrap.Offcanvas.getOrCreateInstance(oc).show();
        window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: res.data }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        btnResult(btn, true);
      })
      .catch(function () {
        cartBusy = false;
        btnLoading(btn, false);
        try { form.submit(); } catch (e) { btnResult(btn, false); }  // native POST fallback
      });
  }

  /* ---------- EMAIL CAPTURE (shared, AJAX → Shopify customer list, native fallback) ----------
     Submits a real Shopify {% form 'customer' %} to /contact over fetch, so the shopper stays on
     the page. Shopify answers a valid signup with a 302 back to the page + ?customer_posted=true
     (the address lands in Customers with "Email subscribed" + our contact[tags]); a rejected one
     re-renders the page WITHOUT redirecting and with the form's error text inside its
     [data-hh-form-error] node. Anything unexpected (offline, blocked fetch) rejects, and the
     caller falls back to a native submit so an address is never silently dropped.
     Returns a Promise<{ ok: boolean, message: string }>. */
  function formError(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nodes = doc.querySelectorAll('[data-hh-form-error], .errors, .form__message--error');
      for (var i = 0; i < nodes.length; i++) {
        var txt = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
        if (txt) return txt;
      }
    } catch (e) {}
    return '';
  }
  function subscribe(form) {
    if (!form) return Promise.reject(new Error('no form'));
    if (!window.fetch || !window.FormData || !window.Promise) return Promise.reject(new Error('unsupported'));
    var action = form.getAttribute('action') || '/contact';
    return fetch(action, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    }).then(function (res) {
      return res.text().then(function (html) {
        var url = res.url || '';
        if (res.redirected || url.indexOf('customer_posted=true') !== -1) return { ok: true, message: '' };
        if (!res.ok && !html) throw new Error('HTTP ' + res.status);
        return { ok: false, message: formError(html) };
      });
    });
  }

  /* public namespace so sections can hook in */
  window.HH = window.HH || {};
  window.HH.initReveal = initReveal;
  window.HH.cartAdd = cartAdd;
  window.HH.subscribe = subscribe;
  window.HH.btnLoading = btnLoading;
  window.HH.btnResult = btnResult;

  /* delegate: any product-card add form submits via AJAX (re-init-safe, no per-section JS) */
  document.addEventListener('submit', function (e) {
    var form = (e.target && e.target.closest) ? e.target.closest('.prod-add-form, [data-hh-cart-add]') : null;
    if (!form) return;
    e.preventDefault();
    cartAdd(form, form.querySelector('button[type="submit"], .prod-add'));
  });

  /* ---------- WISHLIST (client-side, localStorage — no account needed) ----------
     One store of {handle,id,variantId,title,url,image,price}. The heart on any product
     card toggles it (with a premium pop + burst); the nav counter and the wishlist page
     read the same store and react to the `hh:wishlist:change` event. Re-init-safe. */
  var WKEY = 'hh:wishlist';
  function wRead() { try { var v = JSON.parse(localStorage.getItem(WKEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function wWrite(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
    window.dispatchEvent(new CustomEvent('hh:wishlist:change', { detail: { list: list, count: list.length } }));
  }
  var Wishlist = {
    all: function () { return wRead(); },
    count: function () { return wRead().length; },
    has: function (handle) { return wRead().some(function (i) { return i.handle === handle; }); },
    remove: function (handle) { wWrite(wRead().filter(function (i) { return i.handle !== handle; })); },
    add: function (item) {
      if (!item || !item.handle) return;
      var list = wRead();
      if (list.some(function (i) { return i.handle === item.handle; })) return;
      list.unshift(item); wWrite(list);
    },
    toggle: function (item) {
      if (!item || !item.handle) return false;
      if (this.has(item.handle)) { this.remove(item.handle); return false; }
      this.add(item); return true;
    }
  };
  window.HH.wishlist = Wishlist;

  /* sync every wishlist counter + every heart's filled state to the current store */
  function wSyncUI(root) {
    var list = wRead(), n = list.length, on = {};
    list.forEach(function (i) { on[i.handle] = 1; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-hh-wishlist-count]'), function (el) {
      el.textContent = n; el.classList.toggle('show', n > 0);
    });
    Array.prototype.forEach.call((root || document).querySelectorAll('.prod-fav[data-wishlist]'), function (btn) {
      var fav = !!on[btn.getAttribute('data-wishlist-handle')];
      btn.classList.toggle('is-fav', fav);
      btn.setAttribute('aria-pressed', fav ? 'true' : 'false');
      btn.setAttribute('aria-label', fav ? 'Saved to wishlist — click to remove' : 'Save to wishlist');
    });
  }
  window.HH.syncWishlist = wSyncUI;

  /* premium burst: a ring pulse + radiating mini-hearts, on save */
  function heartBurst(btn) {
    if (reduce) return;
    var ring = document.createElement('span'); ring.className = 'hh-fav-ring'; btn.appendChild(ring);
    var burst = document.createElement('span'); burst.className = 'hh-fav-burst';
    for (var i = 0; i < 6; i++) { var p = document.createElement('i'); p.style.setProperty('--a', (i * 60) + 'deg'); p.style.setProperty('--d', (0.015 * i) + 's'); burst.appendChild(p); }
    btn.appendChild(burst);
    setTimeout(function () { ring.remove(); burst.remove(); }, 900);
  }

  /* delegate: click any wishlist heart → toggle + animate */
  document.addEventListener('click', function (e) {
    var btn = (e.target && e.target.closest) ? e.target.closest('.prod-fav[data-wishlist]') : null;
    if (!btn) return;
    e.preventDefault();
    var added = Wishlist.toggle({
      handle: btn.getAttribute('data-wishlist-handle'), id: btn.getAttribute('data-wishlist-id'),
      variantId: btn.getAttribute('data-wishlist-variant'), title: btn.getAttribute('data-wishlist-title'),
      url: btn.getAttribute('data-wishlist-url'), image: btn.getAttribute('data-wishlist-image'),
      price: btn.getAttribute('data-wishlist-price'), subtitle: btn.getAttribute('data-wishlist-subtitle')
    });
    btn.classList.toggle('is-fav', added);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    if (added) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); heartBurst(btn); }
  });
  /* ---------- WISHLIST PAGE render (in this head asset so it works without section JS) ---------- */
  function renderWishlistPage(scope) {
    var roots = (scope || document).querySelectorAll ? (scope || document).querySelectorAll('[data-wishlist-root]') : [];
    Array.prototype.forEach.call(roots, function (root) {
      var grid = root.querySelector('[data-wishlist-grid]'), empty = root.querySelector('[data-wishlist-empty]'), tpl = root.querySelector('template[data-wishlist-card]');
      if (!grid || !empty || !tpl) return;
      var list = wRead();
      grid.innerHTML = '';
      if (!list.length) { empty.hidden = false; grid.hidden = true; return; }
      empty.hidden = true; grid.hidden = false;
      list.forEach(function (it) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        Array.prototype.forEach.call(node.querySelectorAll('[data-link]'), function (a) { a.setAttribute('href', it.url || '#'); });
        var img = node.querySelector('[data-img]'); if (img) { img.src = it.image || ''; img.alt = it.title || ''; }
        var t = node.querySelector('[data-title]'); if (t) t.textContent = (it.title || '').toLowerCase();
        var sub = node.querySelector('[data-subtitle]'); if (sub) sub.textContent = it.subtitle || '';
        var pr = node.querySelector('[data-price]'); if (pr) pr.innerHTML = it.price ? ('<b>' + it.price + '</b>') : '';
        var form = node.querySelector('[data-add-form]'), vin = node.querySelector('[data-variant]');
        if (it.variantId && vin) { vin.value = it.variantId; } else if (form) { form.remove(); }
        var fav = node.querySelector('.prod-fav');
        if (fav) {
          fav.setAttribute('data-wishlist-handle', it.handle || ''); fav.setAttribute('data-wishlist-id', it.id || '');
          fav.setAttribute('data-wishlist-variant', it.variantId || ''); fav.setAttribute('data-wishlist-title', it.title || '');
          fav.setAttribute('data-wishlist-url', it.url || ''); fav.setAttribute('data-wishlist-image', it.image || '');
          fav.setAttribute('data-wishlist-price', it.price || '');
        }
        grid.appendChild(node);
      });
      initReveal(root);
    });
  }
  window.HH.renderWishlistPage = renderWishlistPage;
  window.addEventListener('hh:wishlist:change', function () { wSyncUI(document); renderWishlistPage(document); });

  /* ---------- FAQ / accordion (DELEGATED here so it works on any page — a section's own
     {% javascript %} can fail to run if another section in the page's JS bundle throws; a head
     asset like this one always loads). Toggles the panel referenced by the trigger's aria-controls. */
  function faqToggle(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var item = btn.closest ? btn.closest('.fq-item') : null;
    if (open == null) open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (item) item.classList.toggle('is-open', open);
    if (reduce) { panel.hidden = !open; panel.style.maxHeight = ''; return; }
    if (open) {
      panel.hidden = false;
      panel.style.maxHeight = '0px'; void panel.offsetHeight;
      panel.style.maxHeight = panel.scrollHeight + 'px';
      var o = function (e) { if (e.propertyName !== 'max-height') return; panel.style.maxHeight = 'none'; panel.removeEventListener('transitionend', o); };
      panel.addEventListener('transitionend', o);
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px'; void panel.offsetHeight;
      panel.style.maxHeight = '0px';
      var c = function (e) { if (e.propertyName !== 'max-height') return; panel.hidden = true; panel.style.maxHeight = ''; panel.removeEventListener('transitionend', c); };
      panel.addEventListener('transitionend', c);
    }
  }
  function faqInit(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.fq-trigger[aria-expanded="true"]'), function (btn) {
      var item = btn.closest ? btn.closest('.fq-item') : null;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (item) item.classList.add('is-open');
      if (panel) panel.hidden = false;
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.fq-trigger') : null;
    if (!btn) return;
    var group = btn.closest ? (btn.closest('.hh-page-faq') || document) : document;
    // exclusive accordion: opening one closes the others in the same group
    // (unless the group opts out with data-fq-multi to allow several open at once)
    if (btn.getAttribute('aria-expanded') !== 'true' && !(group.hasAttribute && group.hasAttribute('data-fq-multi'))) {
      Array.prototype.forEach.call(group.querySelectorAll('.fq-trigger[aria-expanded="true"]'), function (o) { if (o !== btn) faqToggle(o, false); });
    }
    faqToggle(btn);
  });
  window.HH.faqInit = faqInit;

  /* ---------- COLLECTION filter/sort — auto-apply the native GET form on change (the "Apply
     filters" button still works without JS; this just makes filtering/sort instant). Delegated
     here so it can't be broken by a section-JS bundle error. ---------- */
  document.addEventListener('change', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('.hc-filter-form') : null;
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
  });
  /* collection: compact "filters" button toggles the panel (delegated — no section JS) */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-hc-filter-toggle]') : null;
    if (!btn) return;
    var scope = btn.closest('.hc-filter-form') || document;
    var panel = scope.querySelector('[data-hc-filters]');
    if (!panel) return;
    var willOpen = panel.hasAttribute('hidden');
    if (willOpen) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  });

  /* ---------- CART quantity steppers — our +/- buttons drive the theme's [name="updates[]"] input,
     which the theme cart.js (<cart-container>) already listens to on native `change`. Delegated at
     the document so it survives every Section-Rendering re-render of the cart. No section JS. ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-hh-qty]') : null;
    if (!btn) return;
    var wrap = btn.closest('.hh-cart-qty');
    var input = wrap ? wrap.querySelector('input[name="updates[]"]') : null;
    if (!input || input.disabled) return;
    var cur = parseInt(input.value, 10); if (isNaN(cur) || cur < 0) cur = 0;
    var next = btn.getAttribute('data-hh-qty') === 'inc' ? cur + 1 : cur - 1;
    if (next < 0) next = 0;
    if (next === cur) return;
    input.value = next;
    /* cart.js's per-input change handler picks this up → AJAX update + re-render */
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- smooth in-page scroll for content anchors (e.g. the "shop <product>" CTA -> #buy),
       offset by the sticky #header-group. Skips Bootstrap toggles (offcanvas / modal / collapse / tabs)
       so the cart / search / menu triggers keep working, and ignores links to other pages. ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || a.hasAttribute('data-bs-toggle') || a.hasAttribute('data-bs-target')) return;
    var hash = a.hash;
    if (!hash || hash.length < 2) return;
    if (a.pathname && a.pathname.replace(/^\//, '') !== location.pathname.replace(/^\//, '')) return;
    var target = null;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (err) { return; }
    if (!target || (target.matches && target.matches('.offcanvas, .modal, .collapse, .tab-pane'))) return;
    e.preventDefault();
    var offset = 0, hdr = document.querySelector('#header-group') || document.querySelector('.hh-header');
    if (hdr) { var r = hdr.getBoundingClientRect(); if (r.top > -2 && r.height) offset = r.height; }
    var y = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - offset - 12);
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) { try { history.replaceState(null, '', hash); } catch (err2) {} }
  });

  function boot() { initReveal(document); wSyncUI(document); faqInit(document); renderWishlistPage(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Shopify theme-editor: re-scan when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); wSyncUI(e.target); faqInit(e.target); renderWishlistPage(e.target); });
})();
